import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a261e12"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "Hackathon",
  class: "hackathon"
}
const _hoisted_2 = { class: "hackathon__text-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hackathon__text-content" }, " We are not doing sponsored tracks instead we want to evaluate the best project in their respective domain. ", -1))
const _hoisted_4 = { class: "hackathon__awards-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "hackathon__awards-item-name" }
const _hoisted_7 = { class: "hackathon__awards-item-price" }
const _hoisted_8 = { class: "hackathon__modal-title" }
const _hoisted_9 = { class: "hackathon__modal-award-price" }
const _hoisted_10 = {
  key: 0,
  class: "hackathon__modal-description"
}

import SectionTitle from "@/components/SectionTitle.vue";
import { ref } from "vue";
type Award = {
  name: string,
  price: string,
  description?: string,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HackathonAwards',
  setup(__props) {

const modalContent = ref<Award | null>(null);


const showModal = (award: Award) => {
  if (award.description) {
    modalContent.value = award;
  } else {
    modalContent.value = null;
  }
}

const awards = [
  {
    name: "Sustainability award",
    price: "2500 EUR",
    description: "Create structures which are long lasting, which will survive generations. Inspire us by solving the puzzle of sustainable existence of humanity or an artificial system. Be an infinite game player!"
  },
  {
    name: "Urbanism award",
    price: "2500 EUR",
    description: "Chances are, you are a city creature. Help to solve some of the issues of municipality infrastructure we are facing today or are soon going to be facing."
  },
  {
    name: "Cryptoeconomics award",
    price: "2500 EUR",
    description: "Prove your genius by inventing new economic systems. Get circular, start a local UBI project or mess with an economy at scale."
  },
  {
    name: "Design award",
    price: "2500 EUR",
    description: "Make your dapp nice and smooth! Tech us about beauty and user experience, young padawan!"
  },
  {
    name: "Smart contract award",
    price: "2500 EUR",
    description: "Make your contracts beautiful! Show us breathtaking structures of code which will orchestrate the symphony of your dapp. For that you shall be remembered and awarded!"
  },
  {
    name: "Hackers' favourite",
    price: "2500 EUR",
    description: "The participating hackers should have their say as well! The project with the most votes from other competing hackers will be awarded the Hacker's favorite."
  },
]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SectionTitle, { title: "hackathon awards" }),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(awards, (award) => {
        return _createElementVNode("div", {
          class: _normalizeClass(['hackathon__awards-item', {'hackathon__awards-item-pointer': award.description}]),
          key: award.name,
          onClick: ($event: any) => (showModal(award))
        }, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(award.name), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(award.price), 1)
        ], 10, _hoisted_5)
      }), 64))
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (modalContent.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "hackathon__modal-dropdown",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (modalContent.value = null))
            }, [
              _createElementVNode("div", {
                class: "hackathon__modal",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(modalContent.value.name), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(modalContent.value.price), 1),
                (modalContent.value.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(modalContent.value.description), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})